import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';

import { logoutAction } from 'store/actions/userActions';
import Users from 'api/classes/Users';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';

interface IDeleteAccountProps {
  onModalClose: () => void,
}

const DeleteAccount: FC<IDeleteAccountProps> = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteAccount = async() => {
    setIsDeleting(true);
    const { success, error }: any = await Users.deleteUser();

    if (success) {
      sendNotification(ENotificationTypes.Success, 'Account deleted successfully');
      dispatch(logoutAction(true));
    } else {
      sendNotification(ENotificationTypes.Error, error);
    }

    onModalClose();
    setIsDeleting(false);
  };

  return (
    <div className="w-96">
      <h2 className="my-4">Delete Account</h2>
      <p className="font-regular">You account will be permanently deleted. Are you sure you want to proceed?</p>
      <Divider />
      <div className="flex items-center justify-between">
        <Button type="link" danger size="small" loading={isDeleting} onClick={handleDeleteAccount}>
          Delete Account
        </Button>
        <Button type="primary" size="large" onClick={onModalClose}>
          Keep Account
        </Button>
      </div>
    </div>
  );
};

export default DeleteAccount;
